import { FC } from 'react'

export const FUND_ORIGIN_DETAIL_MAX_LENGTH = 255

interface IProps {
  value: string
  onChange: (value: string) => void
  loading?: boolean
}

export const FundOriginDetailField: FC<IProps> = ({ value, onChange, loading }) => (
  <div className='col-lg-6 mb-7'>
    <label htmlFor='fundOriginDetail' className='text-muted fs-6 mb-2'>
      Detalle del origen de fondos
    </label>
    <input
      id='fundOriginDetail'
      type='text'
      className='form-control form-control-solid'
      value={value}
      maxLength={FUND_ORIGIN_DETAIL_MAX_LENGTH}
      disabled={loading}
      required
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
)
